import {PossibilitiesWithText} from "./detail_station_common";
import React from "react";

export type PossibilitiesGroup =
  | 'for_moscow'
  | 'with_typing'
  | 'without_registration';

export type PossibilitiesGroupType = {
  [s in PossibilitiesGroup]: PossibilitiesWithText;
}

export const POSSIBILITIES_TYPES: PossibilitiesGroupType = {
  for_moscow: {
    icon: '/static/images/icons/for_moscow.svg',
    acceptIcon: '/static/images/icons/acceptIcon.svg',
    text: 'Почетный донор Москвы',
    popup: <span>Сдавая в этом центре крови можно получить звание Почётного донора Москвы</span>,
  },
  with_typing: {
    icon: '/static/images/icons/with_typing.svg',
    acceptIcon: '/static/images/icons/acceptIcon.svg',
    text: 'Можно пройти типирование',
    popup: <span>Здесь вы можете войти в регистр <a
        style={{color: 'white', textDecoration: 'underline'}}
        href={'https://km.donorsearch.org/'}
        target={'_blank'}
      >доноров костного мозга</a></span>,
  },
  without_registration: {
    icon: '/static/images/icons/without_registration.svg',
    acceptIcon: '/static/images/icons/acceptIcon.svg',
    text: 'Можно без регистрации',
    popup: <span>Центр крови принимает доноров без местной прописки</span>,
  }
};
